import React, { FC, useState } from 'react'
import './returnsticker-selection.scss';
import { RadioGroup } from 'devextreme-react/radio-group'
import NumberBox from 'devextreme-react/number-box';
import TextBox from 'devextreme-react/text-box';
import { useReturnItemService } from 'services';

type Props = {
    isReturnStickerAvailable?: boolean,
    returnSticker? : number | null,
    noReturnStickerReason? : string | null,
    disabled?: boolean,
    isReturnStickerDuplicate?: boolean | null,
    onReturnStickerChanged?: (sticker: number | null) => void
    onNoReturnStickerReasonChanged?: (reason: string | null) => void
    returnStickerControlRef?: (control: any) => void
    noReturnStickerControlRef?: (control: any) => void
    handleRadioChecked?: (itemKey: any) => void,
}

export const ReturnStickerSelection: FC<Props> = ({ isReturnStickerAvailable = true, disabled = false, returnSticker = null, noReturnStickerReason = null, isReturnStickerDuplicate = false, onReturnStickerChanged = () => {}, onNoReturnStickerReasonChanged = () => {}, returnStickerControlRef = () => {}, noReturnStickerControlRef = () => {}, handleRadioChecked = () => {} }) => {

    const { isValidReturnSticker } = useReturnItemService()

    let selectionOptions: string[] = ['Yes', 'No']

    return (
        <>
            <div className={'returnsticker-selection'}>
                <div className={'returnsticker-text'}> Return Sticker </div>
                <div className={'returnsticker-radio'}>
                    <RadioGroup
                        width={'100%'}
                        items={selectionOptions}
                        itemRender={(itemData: any) => <div className={'returnsticker-option'}> {itemData}</div>}
                        layout="horizontal"
                        onValueChanged={e => handleRadioChecked(e.value)}
                        value={isReturnStickerAvailable ? selectionOptions[0] : selectionOptions[1]}
                    />
                </div>
            </div>
            {isReturnStickerAvailable ?
                <>
                    <div className={'returnsticker-field'}>
                        <NumberBox
                            disabled={disabled}
                            value={returnSticker ?? undefined}
                            placeholder="Scan / Enter return sticker"
                            format="#0"
                            onKeyUp={(e: any) => {
                                const sanitizedValue = e.event.target.value.replace(/[^0-9]/g, '');
                                const numericValue = sanitizedValue ? parseInt(sanitizedValue, 10) : null;

                                if (numericValue !== null && numericValue > 0) {
                                    onReturnStickerChanged(numericValue);
                                } else if (sanitizedValue === '') {
                                    onReturnStickerChanged(null);
                                }
                            }}
                            ref={(control) => returnStickerControlRef && returnStickerControlRef(control)}
                        />
                    </div>
                    {returnSticker != null && !isValidReturnSticker(returnSticker) && <div className={'validation-error'}>This is not a valid return sticker. Did you accidentally enter the UPC or manufacturer ID?</div> }
                    {returnSticker != null && isReturnStickerDuplicate && <div className={'validation-error'}>This return sticker is a duplicate. Please enter a new return sticker.</div> }
                </>
                :
                <div className={'returnsticker-field'}>
                    <TextBox
                        disabled={disabled}
                        placeholder="Reason for no return sticker"
                        value={noReturnStickerReason ?? undefined}
                        onKeyUp={(e: any) => onNoReturnStickerReasonChanged(e.event.target.value)}
                        ref={(control) => noReturnStickerControlRef != null && noReturnStickerControlRef(control)}
                    />
                </div>
            }
        </>
    )
}